import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { MOEDA_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    MOEDA_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    MOEDA_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [MOEDA_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [MOEDA_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [MOEDA_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [MOEDA_ENDPOINT],
    id
  );
}
